import { render, staticRenderFns } from "./CharityModal.vue?vue&type=template&id=28ff32be"
import script from "./CharityModal.vue?vue&type=script&lang=js"
export * from "./CharityModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports